export type SortDirection = { id: string; desc?: boolean };

export type FilterPrimitive = string | number | boolean | null | undefined;

export type FilterOperatorMap = Record<string, FilterPrimitive>;

export type FilterValue =
  | FilterPrimitive
  | FilterPrimitive[]
  | FilterOperatorMap
  | { value?: string };

export interface BuildQueryParamsArgs {
  pageSize?: number | string;
  pageIndex?: number | string;
  sortBy?: SortDirection[];
  searchTerms?: string;
  forceSearch?: boolean;
  filters?: Record<string, FilterValue> | null;
}

export const buildQueryParams = ({
  pageSize,
  pageIndex = 0,
  sortBy,
  searchTerms,
  forceSearch,
  filters,
}: BuildQueryParamsArgs): URLSearchParams => {
  const query = new URLSearchParams();

  if (pageSize) query.append('size', String(pageSize));
  query.append('page', String(pageIndex));

  if (!!sortBy?.length) {
    sortBy.forEach((sortParams) => {
      const sortDir = sortParams.desc ? 'desc' : 'asc';

      query.append('sort', `${sortParams.id},${sortDir}`);
    });
  }

  if (searchTerms || forceSearch) query.append('q', searchTerms || '');

  if (filters) {
    Object.keys(filters).forEach((field) => {
      const filterValue = filters[field];

      if (Array.isArray(filterValue) && filterValue.length > 0) {
        query.append(`${field}.in`, filterValue.join(','));
      } else if (typeof filterValue === 'object' && filterValue !== null) {
        const objectValue = filterValue as
          | FilterOperatorMap
          | { value?: string };

        if (field === 'search' && 'value' in objectValue && objectValue.value) {
          query.append('q', String(objectValue.value));
        } else {
          Object.keys(objectValue).forEach((operator) => {
            const operatorValue = (objectValue as FilterOperatorMap)[operator];

            if (operatorValue != null && operatorValue !== '') {
              query.append(`${field}.${operator}`, String(operatorValue));
            }
          });
        }
      } else if (
        filterValue != null &&
        filterValue !== '' &&
        field !== 'search'
      ) {
        query.append(`${field}.equals`, String(filterValue));
      }
    });
  }

  return query;
};
